import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetEventByNameForPeoplePickerQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventByNameForPeoplePickerQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    labels: Array<{ __typename?: 'EventLabel'; id: string; display: string; people: Array<{ __typename?: 'Person'; id: string; personIdTag: string }> }>;
    guests: {
      __typename?: 'EventGuests';
      households: Array<{
        __typename?: 'Household';
        id: string;
        members: Array<{
          __typename?: 'Person';
          id: string;
          personIdTag: string;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          hasEmail: boolean;
          phoneDisplay?: string | null;
          avatarName?: string | null;
          avatar?: { __typename?: 'Photo'; url: string } | null;
          household?: { __typename?: 'Household'; id: string } | null;
        }>;
      }>;
    };
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
  } | null;
};

export const GetEventByNameForPeoplePickerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventByNameForPeoplePicker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'labels' },
                  name: { kind: 'Name', value: 'labels' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'personIdTag' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'guests' },
                  name: { kind: 'Name', value: 'guests' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'households' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'members' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Person' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentForAdmin' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Person' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Person' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'personIdTag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneDisplay' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' }, selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'household' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentForAdmin' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventFragmentCommon' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productVerticals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'info' },
            name: { kind: 'Name', value: 'info' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventFragmentCommon' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventByNameForPeoplePickerQuery__
 *
 * To run a query within a React component, call `useGetEventByNameForPeoplePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByNameForPeoplePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByNameForPeoplePickerQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventByNameForPeoplePickerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>(GetEventByNameForPeoplePickerDocument, baseOptions);
}
export function useGetEventByNameForPeoplePickerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>(GetEventByNameForPeoplePickerDocument, baseOptions);
}
export type GetEventByNameForPeoplePickerQueryHookResult = ReturnType<typeof useGetEventByNameForPeoplePickerQuery>;
export type GetEventByNameForPeoplePickerLazyQueryHookResult = ReturnType<typeof useGetEventByNameForPeoplePickerLazyQuery>;
export type GetEventByNameForPeoplePickerQueryResult = Apollo.QueryResult<GetEventByNameForPeoplePickerQuery, GetEventByNameForPeoplePickerQueryVariables>;
